module.exports = __webpack_public_path__ + "img/electron-seal.ef8dbcd9.png";